import { useCallback } from 'react'

import { useModal } from 'primsell-shared-layer/features'

import * as S from './image-preview-container.styles'

import { ModalVariantCommonE, IImagePreviewModalState, ButtonSizeT } from 'primsell-shared-layer/types'
import { IImagePreviewContainerProps, ImagePreviewContainerSizeT } from './image-preview-container.types'

const buttonPreviewSizeConfig: Record<ImagePreviewContainerSizeT, ButtonSizeT> = {
  small: 'xs',
  medium: 'xs',
  large: 'sm',
}

export const ImagePreviewContainer = ({ previewSrc, modalSrc, alt, size = 'large' }: IImagePreviewContainerProps) => {
  const { openModal } = useModal<IImagePreviewModalState>()
  const handleOpenModal = useCallback(() => {
    if (!modalSrc) {
      return
    }

    openModal({
      variant: ModalVariantCommonE.IMAGE_PREVIEW,
      state: { src: modalSrc },
    })
  }, [modalSrc, openModal])

  return (
    <S.Container size={size}>
      <S.NFTPreview src={previewSrc} alt={alt} />
      {previewSrc && modalSrc && (
        <S.ZoomInButton
          icon={<S.ZoomInIcon size={size} />}
          size={buttonPreviewSizeConfig[size]}
          color="lightGrey"
          onClick={handleOpenModal}
        />
      )}
    </S.Container>
  )
}
